module.exports = __webpack_public_path__ + "img/loading.23f835b2.svg";